import pdpSharedNotifications from '../PdpSharedNotifications/pdpSharedNotifications';
import pdpRespNotificationSaveItemConfig from './PdpRespNotificationSaveItemCallout/pdpRespNotificationSaveItemCalloutConfig';
import pdpRespNotificationSaveToFolderConfig from './PdpRespNotificationSaveToFolderCallout/pdpRespNotificationSaveToFolderCalloutConfig';
import { pdpRespNotificationPreventOnFirstVisitConfig } from './PdpRespNotificationPreventOnFirstVisit/pdpRespNotificationPreventOnFirstVisitConfig';

export default [
    pdpRespNotificationPreventOnFirstVisitConfig,
    pdpRespNotificationSaveItemConfig,
    pdpRespNotificationSaveToFolderConfig,
    ...pdpSharedNotifications,
];
